module.exports = __webpack_public_path__ + "static/media/demi-hero.e339b79f.png";